import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _images = /*#__PURE__*/new WeakMap();
var _pageBuilderID = /*#__PURE__*/new WeakMap();
var _handlers = /*#__PURE__*/new WeakMap();
class StoreImages {
  constructor() {
    _classPrivateFieldInitSpec(this, _images, []);
    _classPrivateFieldInitSpec(this, _pageBuilderID, null);
    _classPrivateFieldInitSpec(this, _handlers, {
      toggleModal: () => {},
      onSelect: () => {}
    });
    _defineProperty(this, "toggleModal", () => {
      _classPrivateFieldGet(_handlers, this).toggleModal();
    });
    _defineProperty(this, "handleSelectedImage", imageId => {
      const idx = _classPrivateFieldGet(_images, this).findIndex(img => img.imageId === imageId);
      if (idx !== -1) _classPrivateFieldGet(_handlers, this).onSelect(idx);
    });
  }
  get images() {
    return [..._classPrivateFieldGet(_images, this)];
  }
  resetImages() {
    _classPrivateFieldSet(_images, this, []);
  }
  setHandlers({
    toggleModal,
    setSelectedImage
  }) {
    if (typeof toggleModal === 'function') _classPrivateFieldGet(_handlers, this).toggleModal = toggleModal;
    if (typeof setSelectedImage === 'function') _classPrivateFieldGet(_handlers, this).onSelect = setSelectedImage;
  }
  addImages(newImages, {
    pageBuilderID
  } = {}, handlers = {}) {
    if (!Array.isArray(newImages) || newImages.length === 0) {
      return this.images;
    }
    if (pageBuilderID != null && pageBuilderID !== _classPrivateFieldGet(_pageBuilderID, this)) {
      this.resetImages();
      _classPrivateFieldSet(_pageBuilderID, this, pageBuilderID);
    }
    const merged = _classPrivateFieldGet(_images, this).concat(newImages);
    _classPrivateFieldSet(_images, this, Array.from(new Map(merged.map(img => [img.imageId, img])).values()));
    this.setHandlers(handlers);
    return this.images;
  }
}
export default new StoreImages();
//# sourceMappingURL=StoreImages.js.map